import { NavLink } from 'react-router-dom';
import type { ReactNode } from 'react';
import { PlusIcon, RecipeIcon, ScaleIcon, SettingsIcon, TodayIcon } from './icons.js';
import { OfflineBanner } from './OfflineBanner.js';

const NAV_ITEMS = [
  { to: '/', label: 'Heute', Icon: TodayIcon, end: true },
  { to: '/add', label: 'Hinzufügen', Icon: PlusIcon, end: false },
  { to: '/recipes', label: 'Rezepte', Icon: RecipeIcon, end: false },
  { to: '/weight', label: 'Gewicht', Icon: ScaleIcon, end: false },
  { to: '/settings', label: 'Profil', Icon: SettingsIcon, end: false },
] as const;

export function Layout({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div className="app">
      {/* Above the content on every screen: a queue the user cannot see is a
          queue they will not trust. */}
      <OfflineBanner />

      <main className="app-main">{children}</main>

      <nav className="bottom-nav" aria-label="Hauptnavigation">
        {NAV_ITEMS.map(({ to, label, Icon, end }) => (
          <NavLink key={to} to={to} end={end}>
            <Icon />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
